export const ToastStyle = {
  position: 'top-right',
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

export const listNonArrayString = [
  'title_En',
  'title_Te',
  'ahaLink',
  'distributedBy_En',
  'movieCast',
  'movieCast_Te',
  'etvApp',
  'hotstarLink',
  'narratedBy_En',
  'narratedBy_Te',
  'netflixLink',
  'primeLink',
  'sonyLiv',
  'sunNextLink',
  'youtubeLink',
  'zee5Link',
  'ageRestriction',
  'distributedBy_Te',
  'basedOn_Te',
  'basedOn_En',
  'about_Te',
  'about_En',
  'posterURL',
]
export const CSSStylesLocal1 = {
  main: { width: '25rem', display: 'flex', flexwrap: 'wrap', flexWrap: 'wrap', gap: '4px' },
}
export const CSSStylesLocal11 = {
  main: {
    width: '25rem' /*  height: `${readMorecss}`, */,
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px',
  },
}
export const CSSStylesLocalcast = {
  main: { width: '70rem', display: 'flex', flexwrap: 'wrap', flexWrap: 'wrap', gap: '6px' },
}
export const CSSStylesLocalcast11 = {
  main: {
    width: '25rem' /*  height: `${readMorecss}`, */,
    display: 'flex',
    flexWrap: 'wrap',
    gap: '7px',
  },
}
export const CSSStylesLocal2 = {}
export const heightChangeDiv1 = {
  main: {
    display: 'flex',
    cursor: 'pointer',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
}
export const heightChangeDiv2 = {
  main: { cursor: 'pointer', display: 'flex', justifyContent: 'space-between' },
}
export const heightChangeDiv3 = {
  main: {
    flexDirection: 'column',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
  },
}
export const displayNoneStyle = { main: { display: 'none' } }
export const displayNoneStyleCast = { main: { display: 'flex' } }
export const crewArray = [
  'movieDirectedBy',
  'movieDirectedBy_Te',
  'movieProducedBy',
  'movieProducedBy_Te',
  'movieCinematography',
  'movieCinematography_Te',
  'movieEditedBy',
  'movieEditedBy_Te',
  'movieMusicBy',
  'movieMusicBy_Te',
  'movieDialogueBy',
  'movieDialogueBy_Te',
  'movieWrittenBy',
  'movieWrittenBy_Te',
  'movieScreenplayBy',
  'movieScreenplayBy_Te',
  'movieStoryBy',
  'movieStoryBy_Te',
]
export const unEditedFeilds = [
  'PK',
  'allMoviesReleasedDate',
  'movieCast',
  'movieCast_Te',
  'movieProducedBy',
  'movieProducedBy_Te',
  'movieCinematography',
  'movieCinematography_Te',
  'movieDirectedBy',
  'movieDirectedBy_Te',
  'movieEditedBy',
  'movieEditedBy_Te',
  'movieMusicBy',
  'movieMusicBy_Te',
  'SK',
  'movieID',
  'Sno',
  'Action',
  'check',
  'country',
  'contentType',
  'posterURL',
  'movieDialogueBy',
  'movieWrittenBy',
  'movieScreenplayBy',
  'movieStoryBy',
  'movieDialogueBy_Te',
  'movieWrittenBy_Te',
  'movieScreenplayBy_Te',
  'movieStoryBy_Te',
  'tags',
  'adminTagsGood',
  'adminTagsBad',
]
export const onlyChipTypePath = [
  'allMoviesReleasedDate',
  'movieReleasedDateUI',
  'ottReleasedDate',
  'ottReleasedDateUI',
  'ageRestriction',
  'genre_En',
  'genre_Te',
  'ottPlatform',
]
export const crewArrayList = [
  'movieCast',
  'movieCast_Te',
  'movieDirectedBy',
  'movieDirectedBy_Te',
  'movieProducedBy',
  'movieProducedBy_Te',
  'movieCinematography',
  'movieCinematography_Te',
  'movieEditedBy',
  'movieEditedBy_Te',
  'movieMusicBy',
  'movieMusicBy_Te',
  'movieDialogueBy',
  'movieDialogueBy_Te',
  'movieWrittenBy',
  'movieWrittenBy_Te',
  'movieScreenplayBy',
  'movieScreenplayBy_Te',
  'movieStoryBy',
  'movieStoryBy_Te',
]
export const paths = [
  'movieDirectedBy',
  'movieProducedBy',
  'movieCast',
  'movieCinematography',
  'movieEditedBy',
  'movieMusicBy',
  'movieDialogueBy',
  'movieWrittenBy',
  'movieScreenplayBy',
  'movieStoryBy',
  'movieDirectedBy_Te',
  'movieProducedBy_Te',
  'movieCast_Te',
  'movieCinematography_Te',
  'movieEditedBy_Te',
  'movieMusicBy_Te',
  'movieDialogueBy_Te',
  'movieWrittenBy_Te',
  'movieScreenplayBy_Te',
  'movieStoryBy_Te',
]
export const CastAndCrew = [
  'movieDirectedBy',
  'movieProducedBy',
  'movieCast',
  'movieCinematography',
  'movieEditedBy',
  'movieMusicBy',
  'movieDialogueBy',
  'movieWrittenBy',
  'movieScreenplayBy',
  'movieStoryBy',
  'movieDirectedBy_Te',
  'movieProducedBy_Te',
  'movieCast_Te',
  'movieCinematography_Te',
  'movieEditedBy_Te',
  'movieMusicBy_Te',
  'movieDialogueBy_Te',
  'movieWrittenBy_Te',
  'movieScreenplayBy_Te',
  'movieStoryBy_Te',
]
export const crewDataEn = [
  'movieCinematography',
  'movieDirectedBy',
  'movieProducedBy',
  'movieEditedBy',
  'movieMusicBy',
  'movieDialogueBy',
  'movieScreenplayBy',
  'movieWrittenBy',
  'movieStoryBy',
  'movieScreenplayBy',
]
export const crewDataTe = [
  'movieCinematography_Te',
  'movieDirectedBy_Te',
  'movieProducedBy_Te',
  'movieEditedBy_Te',
  'movieMusicBy_Te',
  'movieDialogueBy_Te',
  'movieScreenplayBy_Te',
  'movieWrittenBy_Te',
  'movieStoryBy_Te',
  '',
]
export const allCrewPaths = [
  'movieMusicBy_Te',
  'movieMusicBy',
  'movieStoryBy_Te',
  'movieStoryBy',
  'movieScreenplayBy_Te',
  'movieScreenplayBy',
  'movieWrittenBy_Te',
  'movieWrittenBy',
  'movieDialogueBy_Te',
  'movieDialogueBy',
  'movieEditedBy_Te',
  'movieEditedBy',
  'movieCinematography_Te',
  'movieCinematography',
  'movieProducedBy_Te',
  'movieProducedBy',
  'movieDirectedBy_Te',
  'movieDirectedBy',
]
